import React from 'react';
import { cn } from '../lib/utils';
import { Avatar, AvatarFallback } from './ui/avatar';

/** Extract initials from a name, accepting either "John" or "John Doe" style names */
function getInitials(name: string): string {
  if (!name) return '?';
  return name.trim().split(/\s+/)[0][0]?.toUpperCase() || '?';
}

export interface ProfileIconProps {
  identifier: string;
  size?: number;
  className?: string;
}

export const ProfileIcon: React.FC<ProfileIconProps> = ({ identifier, size = 40, className }) => {
  const initials = getInitials(identifier);

  return (
    <Avatar
      className={cn('bg-primary', className)}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <AvatarFallback className="bg-primary text-sm font-medium text-white">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
};

export default ProfileIcon;
